import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { AssetVoucherFilter, Voucher_Type } from "./VoucherServices";

// V1/API/Acc_Draft/
class DraftService {
  route = `V1/API/Billing/Acc_Draft`;

  // post & eidt api
  postVoucherDraft = (
    companyId: string | undefined,
    voucherType: Voucher_Type,
    params: any,
    id?: string
  ) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}${
        id ? "/" + id : ""
      }?voucherType=${voucherType}`,
      params
    );

  // delete Draft
  deleteDraft = (companyId: string, draftId: string) =>
    ApiUtility.delete(`${this.route}/${companyId}/${draftId}`);

  // get by id Draft
  // draftId;
  getByDraftId = (companyId: string, draftId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/${draftId}`);

  // GetDraftList
  getVoucherDraftList = (
    companyId: any,
    voucherType: Voucher_Type | any,
    from: string,
    to: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    partyId?: string,
    // reconciled?: ReconcileTypes | any,
    search?: string,
    // status?: VoucherFilterStatus,
    // itemId?: string
    assetVoucherFilter?: AssetVoucherFilter
  ) =>
    ApiUtility.get(`${this.route}/${companyId}/GetDraftList`, {
      voucherType,
      from,
      to,
      start,
      length,
      sortCol,
      sortDir,
      partyId,
      //   reconciled,
      search,
      //   status,
      // itemId,
      assetVoucherFilter,
    });
}
export default new DraftService();
